import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import FeaturesSection from "./components/FeaturesSection";
import EarnMechanism from "./components/EarnMechanism";
import Testimonials from "./components/Testimonials";
import TrustBadges from "./components/TrustBadges";
import FAQSection from "./components/FAQSection";
import DownloadSection from "./components/DownloadSection";

export default function Home() {
  return (
    <div className="min-h-screen font-sans">
      <Navbar />
      <HeroSection />
      <FeaturesSection />
      <EarnMechanism />
      <Testimonials />
      <TrustBadges />
      <FAQSection />
      <DownloadSection />
    </div>
  );
}
